<template>
	<div class="contentPage woStatistics">
		<div class="woStatisticsScroll">
			<div class="woStatistics_title">Work orders statistics</div>
			<div class="tabBlock">
				<div>
					<v-tabs
							class="tabList"
							v-model="tab"
							center-active
							height="40"
					>
						<v-tabs-slider color="#4CAF50"></v-tabs-slider>
						<v-tab
								v-for="item in getTabList"
								:disabled="item.disabled"
								:key="item.text"
								class="tab"
								:class="{'errorTab': item.error}"
						>
							{{ item.text }}
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab">
						<v-tab-item v-if="permissions[69]">
							<planer v-if="!tab" :tab="tab"></planer>
						</v-tab-item>
						<v-tab-item v-if="permissions[70]">
							-
						</v-tab-item>
						<v-tab-item v-if="permissions[68]">
							<analytics></analytics>
						</v-tab-item>
						<v-tab-item v-if="permissions[73]">
							<motivation-program></motivation-program>
						</v-tab-item>
					</v-tabs-items>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import Analytics from "@/components/Fleet/WorkOrdersStatistics/Analytics/Analytics";
import MotivationProgram from "@/components/Fleet/WorkOrdersStatistics/MotivationProgram/MotivationProgram";
import Planer from "@/components/Fleet/WorkOrdersStatistics/Planer/Planer";

export default {
	name: "WorkOrdersStatistics",
	components: { Analytics, MotivationProgram, Planer },
	computed: {
		...mapGetters([ 'permissions' ]),
		getTabList() {
			const values = [];

			if (this.permissions[69]) {
				values.push({
					text: 'Planner',
					error: false,
					disabled: false
				});
			}

			if (this.permissions[70]) {
				values.push({
					text: 'Downtime',
					error: false,
					disabled: true
				});
			}

			if (this.permissions[68]) {
				values.push({
					text: 'Analytics',
					error: false,
					disabled: false
				});
			}

			if (this.permissions[73]) {
				values.push({
					text: 'Motivation program',
					error: false,
					disabled: false
				});
			}

			values.some((item, idx) => {
				if (!item.disabled) {
					this.tab = idx;
					return true;
				}
			});

			return values;
		},
	},
	data: () => ({
		tab: 0,
	}),
	methods: mapActions([ 'onLogin' ]),
	async created() {
		await this.onLogin('Work orders statistics');
	}
};
</script>

<style scoped lang="scss">
@import "WorkOrdersStatistics";
</style>
<style lang="scss">
@import "WorkOrdersStatisticsAll";
</style>
